// extracted by mini-css-extract-plugin
export var draggableSliderItem = "draggableSlider-module--draggable-slider-item--c864e";